import React,{useState,useEffect} from 'react'
import {Box, TextField, FormControl, Tooltip, LinearProgress,
    FormControlLabel, FormLabel, RadioGroup, Checkbox, Card,
    Typography, Radio} from '@material-ui/core' 
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";
import { format } from 'date-fns'
import {DatePicker,MuiPickersUtilsProvider} from '@material-ui/pickers';
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Modal from '../generales/ModalCerrarActualiza';
import moment from 'moment'
import MapaAlerta from '../perfiles/MapaAlerta'
import {llamadaApiToken,ErrorGeneral,llamadaApiCarga,llamaApiCargaToken } from '../funciones/ClienteAxios';
import { toast } from 'react-toastify'; 
import { obtenDispo } from '../funciones/IdDispositivo';
//import SelectEdo from '../generales/SelectEdo';
import SelectList from '../generales/SelectList';
 
const ModalAbogado = ({modalAbierto,setModalAbierto ,titulo, funcActualizar }) => {
    let history = useHistory();      
    const auxDispV =obtenDispo() 
    const source = axios.CancelToken.source();   
    const usuId =localStorage.getItem('UsuId') ;  
    const fechaMax = moment(new Date()).subtract(20,'years')          
    //const fechaMax = moment("2005-06-30T00:00:00")   
    const[perfil,setPerfil]= useState({Nombre:'', FNacimien:fechaMax, Email:'', calle:'',
                                                Tel:'', ine:"", Municipio:null, Seccion:null, plantilla:0,
                                                edo:null, referente:2, genero:"H", apPat:"", apMat:"",ManualCheck:false,
                                                cedula:"", curp:"", Celular:""
                                            });      
    const [espera,setEspera]= useState(false);
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(true)
    const [aviso, setAviso] = useState(false);    
    const[posicion,setPosicion]= useState({Lat:0,Lon:0})
    const[mensajePos,setMensajePos]= useState("")
    const[cambioEfectivo,serCambioEfectivo] = useState(false)    
    const[nvoRegistro, setNvoRegistro] = useState([])       
    const[arrError,setArrError] = useState([false,false,false,false,false,false])     
    const[listMun, setListMun] = useState([])   
    const[listSecc, setListSecc] = useState([])      
    const[btnLeyenda, setBtnLeyenda] = useState("Guardar")      
    const[modalVald, setModalVald] = useState(false)      
    const{Nombre, FNacimien, calle, Tel, ine, Municipio, Seccion,  Email, genero, apPat, apMat, ManualCheck, cedula, curp, Celular}=perfil

    useEffect(()=>{   
        //setTimeout(() => { setModalVald(true) }, 2000);   
        setPerfil({...perfil,//plantilla:listPlantilla[0].Id,
            edo: localStorage.getItem('prflEdo')??null,
            Seccion: localStorage.getItem('prflSecc')??null,
        })
        //console.log(obtnFch());
        getListMuni(15)
      //  getLocation()
    },[])   

/*     useEffect(() => {
        if (Municipio) {
            getListSecc(Municipio.Id)
        }
            
    }, [Municipio]) */

    function getLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(showPosition);
        } 
        else 
        {   setMensajePos( "La Geolocalizacion no es soportada por tu navegador.");
            setPosicion([])
        }
    }
      
    function showPosition(position) {
        let Latitude= position.coords.latitude ;
        let Longitude= position.coords.longitude;
        //console.log("sin obtener la location");
        /* Geocode.fromLatLng(Latitude, Longitude).then(
            (response) => {
              const address = response.results[0].formatted_address;
              console.log(address);
            },
            (error) => {
              console.error(error);
            }
        ); */
       // console.log({lat:Latitude,Lng:Longitude});
        setPosicion({Lat:Latitude,Lon:Longitude})
    }

    function getListMuni(auxEdo)  {            
        const url= `lugar-municipio`;                            
        const data = qs.stringify({                
            usuario:usuId,              
            estado:auxEdo,                                                
            idDispositivo:auxDispV,
        });
                    
        function respuesta (aux) 
        {   if (aux[0].Id != -1) 
            {   setListMun(aux) 
               // filtroMun(aux)               
            }  
            else{
                setListMun([])
            }                                                                    
        }
        llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
    };

    const getListSecc = (auxMuni) => {
        const data = qs.stringify({
            usuario: usuId, municipio: auxMuni, idDispositivo: auxDispV,
        });
        const url = "lugar-seccion";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {                
                setListSecc(auxiliar)

            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const filtroMun=(aux)=>{
        if (localStorage.getItem('prflMuni')) 
        {
            const filtro=aux.filter((mun)=>mun.Id ===parseInt(localStorage.getItem('prflMuni'))) 
            setPerfil({...perfil,Municipio:filtro[0]??null})
        }else{
            setPerfil({...perfil,Municipio:null,Seccion:null})
        }       
    }

    const RelojFNacimiento = ()=>
    { return <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>            
        <Tooltip title="Seleccionar Fecha Nacimiento">
          <Box  mr={1}  component="span" width={1/4}>           
            <DatePicker style={{width:8.3+'rem'}}
              disableFuture  format="dd/MM/yyyy"
              views={["year", "month", "date"]}
              label="Fecha Nacimiento" size="small"
              openTo="year" cancelLabel={"Cancelar"}                  
              okLabel="Seleccionar"    
              minDate="1900-03-14" maxDate={fechaMax}
              value={FNacimien} onChange={guardarFNaci}            
            />                          
          </Box>    
        </Tooltip>                                             
        </MuiPickersUtilsProvider>
    }

    const guardarFNaci = auxfecha =>
    {   
        setPerfil({ ...perfil,FNacimien : auxfecha  })
    };

    const onChange = e =>
	{   let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$.@#_&-+()/:;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setPerfil({...perfil,[e.target.name] : e.target.value})            
        }		
	};       
    
    const onChangeDir = e =>
	{   let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$.@#_&-+()/:;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setPerfil({...perfil,[e.target.name] : e.target.value})  
            if (e.target.value.length>=3) {
                setBtnDeshabilitado(false)                     
            }            
            else{
                setBtnDeshabilitado(true)                     
            }          
        }		
	};             


    const onChangeNom = e =>
	{   let expNopermitida = new RegExp('[0-9$.@#_&-+()/:;!?,<>=%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setPerfil({...perfil,[e.target.name] : e.target.value})            
        }		
	}; 

    const verifiNombre = () => {                   
        const data = qs.stringify({
            cadena:`${Nombre.trim()} ${apPat.trim()} ${apMat.trim()}`,    
            idDispositivo: auxDispV,
        });
        const url = "perfil-verifica-cadena";
        function respuestaNombre(auxiliar){        
            const isEmpty = Object.keys(auxiliar).length === 0                        
            let auxArr=arrError
            if (isEmpty || auxiliar.coincidencia===0 ||  auxiliar.coincidencia==="0"   ) 
            {                             
                auxArr[3]=false 
                setArrError(auxArr)            
                 
            } 
            else 
            {   const auxmsj = "Nombre invalido, ingrese un Nombre diferente.";
                toast.warning(auxmsj,{
                    pauseOnFocusLoss: false,                    
                    toastId: `nvo-perfil${5}`
                })              
                mandaAlerta(auxmsj, "warning");              
                auxArr[3]=true                                
                setArrError(auxArr)
                setBtnDeshabilitado(false)           
            }         
        }
        llamadaApiCarga(data, url, respuestaNombre,ErrorGeneral,setEspera,history);
    };

    const obtnFch=()=>{
        return `${moment( FNacimien).format('YYYY-MM-DD')}T00:00:00` 
        //return `${format(FNacimien,'YYYY-MM-DD')}T00:00:00` 
    }   



    const onChangeNumTel = e =>
	{   let expNopermitida= new RegExp('[A-Za-z$@#_&-+()/:;!?,<>=]');          
        let expMenos = new RegExp("'");
        let expMas = new RegExp('-');     
        let expCadena = new RegExp('[.0-9$]');             
        if (  e.target.value.length<=10 &&( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
            && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
            || e.target.value===' '|| e.target.value==='') 
        {
            setPerfil({ ...perfil,[e.target.name] : e.target.value })            
      
        }		    

	}; 
     
    function getNvoAbogad()  {               
        const url=`abogado/new-edit`;    
                                                                                   
        const dataInfo = qs.stringify({                                                                                                   
            usuario:usuId,
            llave:0,
            tipo:1,
            status:1,
            estado:15,
            municipio:Municipio.Id,
            nacimiento:obtnFch(),
            ine:ine,
            curp:curp,
            cedula:cedula,
            genero:genero,
            nombre:Nombre.trim(), 
            paterno:apPat.trim(),
            materno:apMat.trim(),
            direccion:calle,
            celular:Celular,
            telefono:Tel,
            email:Email,
            idDispositivo:auxDispV,
            ip:"127.0.0.0"
        });

        function respuesta (aux) {                                                                                 
            if (aux?.respuesta!==0) 
            {                               
                setBtnDeshabilitado(true)                                             
                const mensaje="Se registro correctamente el Abogado"
                setTipoAdvertencia("success")      
                setMensaje(mensaje);                
                setAviso(false);
                toast.success(mensaje,{
                    pauseOnFocusLoss: false,                    
                    toastId: `nvo-abogado${1}`
                })
                
                funcActualizar()
                setModalAbierto(false);
                setNvoRegistro(aux)
                serCambioEfectivo(true) 
                
            }                                            
        }     
        llamaApiCargaToken(dataInfo, url, respuesta, ErrorGeneral, setEspera, history, source);  
    };

    const onChangeClaves = e =>
	{   let expNopermitida = new RegExp('[$@#_&-+()/.;!?,<>=%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) &&
            !expMas.test(e.target.value) ) || e.target.value===' '|| e.target.value==='') 
        { 
            setPerfil({ ...perfil, [e.target.name] : e.target.value.toUpperCase() })
            if (aviso) 
            {   setMensaje('');
                setAviso(false);
            }
        }		
	};     

    
    const onChangeCorreo = e =>
	{   let expNopermitida = new RegExp('[$&+()/;!?,<>=%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9@_.]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) &&
            !expMas.test(e.target.value) ) || e.target.value===' '|| e.target.value==='') 
        { 
            setPerfil({ ...perfil, [e.target.name] : e.target.value })
            if (aviso) 
            {   setMensaje('');
                setAviso(false);
            }
        }		
	};  

    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;        
          
        if(campo===null|| (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;                 
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }
  
    const mandaAlerta=(mensaje,tipoAdvert)=>
    {
        setMensaje(mensaje);
        setTipoAdvertencia(tipoAdvert)  
        setAviso(true);      
    }
      
    function validaVariable(auxCampo,auxMensaje,auxTamanio) 
    {   let respuesta=false
        if ( !verificaNulos(auxCampo,auxMensaje) ) 
        {   if (auxCampo.length>=auxTamanio ) 
            {                
                respuesta=true                    
            }else
            {            
                mandaAlerta('Campo '+auxMensaje +' incompleto, debe escribir un '+ auxMensaje+' valido',"warning") 
            }
        }        
        return respuesta;
    }
       
    function validaVariable2(auxCampo,auxMensaje,auxTamanio) 
    {   let respuesta=false
        if ( !verificaNulos(auxCampo,auxMensaje) ) 
        {   if (auxCampo.length>=auxTamanio ) 
            {                
                respuesta=true                    
            }else
            {            
                mandaAlerta(`Campo ${auxMensaje} incompleto, debe escribir minimo ${auxTamanio} caracteres`,"warning") 
            }
        }        
        return respuesta;
    }

    const guardarMuni=(e)=>{    
        if (e!== null && e!== undefined) 
        {                            
            setPerfil({ ...perfil, Municipio : e  , Seccion :""  })      
            setMensaje('');                
            setAviso(false);             
            localStorage.setItem('prflMuni',e.Id)    
            localStorage.removeItem("prflSecc")   
        }else
        {   setPerfil({...perfil, Municipio : "" ,Seccion :""   })                       
        }        
    }

    const onchangeLocal=(e)=>{
        switch (e.target.name ) {
            case 'edo':                
                localStorage.setItem('prflEdo',e.target.value)     
                localStorage.removeItem("prflMuni")    
                localStorage.removeItem("prflSecc")     
                break;
            case 'Seccion':
                localStorage.setItem('prflSecc',e.target.value)        
                break;                                
            default:
                break;
        }        
    }

    const onChangeSlct=(e)=>{            
         if (e!== null && e!== undefined) 
        {   setPerfil({...perfil,[e.target.name]:e.target.value})   
            onchangeLocal(e)
        }
        else
        {   setPerfil({...perfil,[e.target.name]:""})          
        }        
    }

    const onChangeGen = e =>
    {  
        setPerfil({ ...perfil, genero: e.target.value  })        
    };
    
 

    function guardarDatos(e)
    {   e.preventDefault()                
        if (!verificaNulos(Municipio,"Municipio") &&
            validaVariable(Nombre,'Nombre',3) && validaVariable(apPat,'Apellido Paterno',3) &&
            validaVariable(apMat,'Apellido Materno',3) &&
            validaVariable2(cedula,"Cedula",10) && validaVariable2(curp,"Curp",18) && validaVariable2(ine,"Ine",18)
             && validaVariable(Tel,'Telefono',10) && validaVariable(Celular,'Celular',10)
            && validaVariable(Email,'Email',3) && validaVariable(calle,'Dirección',3))
        {           
            setMensaje('');                
            setAviso(false);               
            setBtnDeshabilitado(true)              
            getNvoAbogad()                  
        }                                  
    } 
      
    const DatosGenerales=(
        <div>
                       
            <Box  mt={1} mb={1} display="flex" flexDirection={"row"}>       
                          
                {listMun.length!==0 ?
                <Autocomplete
                    id="muni-select-nvoPerfil" size='small' style={{ width: 20.7+'rem' }}
                    onChange={(e,option)=>guardarMuni(option)}  value={Municipio}      
                    getOptionLabel={(option) => option.Nom} name="Municipio"             
                    noOptionsText={"Sin coincidencias"} options={listMun}
                    renderInput={(params) => (
                        <TextField {...params} size='small' 
                        label="Municipio" variant="outlined" />
                    )} 
                />
                :<LinearProgress/>}                           
                 {/*  {listSecc.length!==0 ?                
                <Box display={"flex"} mb={1}>
                     <SelectList lista={listSecc} value={Seccion} onChange={onChangeSlct} 
                        etqVal={"Id"} etqId="Id" etqAlias={"Numero"} etiq={"Sección"} 
                        estilo={{marginLeft:1+'rem', minWidth:8.5+'rem'}} nameEtq={"Seccion"}
                        tipo="outlined"
                    />                 
                </Box> 
                :   null
                } */}
            </Box>            
           <Box>
            <TextField required id="Nombre-input" onChange={onChangeNom} style={{paddingBottom:.5+'rem',width:10+'rem',marginRight:".5rem"}}
                label="Nombre" value={Nombre} name='Nombre'size="small" autoComplete='off' // defaultValue="Nombre"                
                //auxArrerror={arrError[3]} onBlur={()=>verifiNombre()}
            />
            
            <TextField required id="apPat-input" onChange={onChangeNom} style={{paddingBottom:.5+'rem',width:10+'rem',marginRight:".5rem"}}
                label="Apellido Paterno" value={apPat} name='apPat'size="small" autoComplete='off' // defaultValue="apPat"                
                //auxArrerror={arrError[3]} onBlur={()=>verifiNombre()}
            />

            <TextField required id="apMat-input" onChange={onChangeNom} style={{paddingBottom:.5+'rem',width:10+'rem'}}
                label="Apellido Materno" value={apMat} name='apMat'size="small" autoComplete='off' // defaultValue="apMat"                
                //auxArrerror={arrError[3]} onBlur={()=>verifiNombre()}
            />
            </Box>
            <Box mt={1}>
              {/*   <SelectEdo edo={edo} onChangeSlct={onChangeSlct} tipo="outlined" /> */}
              {RelojFNacimiento()}
                <FormControl component="fieldset" size='small' style={{marginLeft:1+'rem'}}>          
                    <FormLabel  htmlFor="Género" size='small'>Género</FormLabel>        
                    <RadioGroup  row aria-label="position"  defaultValue="top" size='small'
                        name="genero" value={genero} onChange={onChangeGen}
                    >
                        <FormControlLabel value='H'  size='small'
                            control={<Radio color="primary" size='small'/>} label="Hombre" />    
                        <FormControlLabel value='M'   
                            control={<Radio color="primary" size='small' />} label="Mujer" />                         
                        <FormControlLabel value='X'   
                            control={<Radio color="primary" size='small' />} label="No Binario" />                         
                    </RadioGroup>                     
                </FormControl>
            </Box> 
            <Box>
              <TextField  id="cedula-input" onChange={onChangeClaves} style={{paddingBottom:1+'rem',width:10+'rem',paddingRight:1+'rem',}}
                label="Cedula"  value={cedula} name='cedula' size="small" autoComplete='off' inputProps= {{ maxlength: 16 }} 
            />  
                 <TextField  id="curp-input" onChange={onChangeClaves} style={{paddingBottom:1+'rem',width:13+'rem',paddingRight:1+'rem', }}
                label="Curp"  value={curp} name='curp' size="small" autoComplete='off' inputProps= {{ maxlength: 18 }} 
            />
           <TextField  id="ine-input" onChange={onChangeClaves} style={{paddingBottom:1+'rem',width:13+'rem',paddingRight:1+'rem',}}
                label="Ine"  value={ine} name='ine' size="small" autoComplete='off' inputProps= {{ maxlength: 18 }} 
            />   
            </Box> 
            <Box mb={1}>
                <TextField  id="CInt-input" onChange={onChangeNumTel} style={{width:8+'rem',marginRight:"1rem"  }}
                    label="Teléfono" defaultValue="Tel" value={Tel} name='Tel' size="small" type="number"
                    inputProps= {{ maxlength: 10 }} autoComplete='off'
                /> 
            
            
                    <TextField  id="CInt-input" onChange={onChangeNumTel} style={{width:7+'rem'}}
                    label="Celular"  value={Celular} name='Celular' size="small" type="number"
                    inputProps= {{ maxlength: 10 }} autoComplete='off'
                />
            </Box>
           {/*  <br/>
            <FormControlLabel  style={{marginLeft:".5rem"}}
                disabled={espera} label="Escribir dirección" size={'small'}
                control={<Checkbox color="primary" checked={ManualCheck} name={"ManualCheck"}/>}                
                labelPlacement="end"  onChange={onChangeCheck}
            />
            <br/> */}
            <Box>
             <TextField  id="email-input" onChange={onChangeCorreo} style={{paddingBottom:1+'rem',width:34+'rem'}}
                label="Email"  value={Email} name='Email' size="small" autoComplete='off' //inputProps= {{ maxlength: 18 }} 
                variant='outlined'
            /> </Box>

           <Box>
            <TextField  id="calle-input" onChange={onChangeDir} style={{paddingBottom:1+'rem',width:34+'rem'}}
                label="Dirección"  value={calle} name='calle' size="small" autoComplete='off' //inputProps= {{ maxlength: 18 }} 
                maxRows={3} multiline variant='outlined'
            />  </Box> 
         
        </div> 
    )     

    const cerrarBorrar = () => {            
        setAviso(false);
        setModalAbierto(false);
        if (cambioEfectivo) 
        {  
                                     
        }
    };
 

    return (           
    <Modal
        titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} btnDeshabilitado={btnDeshabilitado}
        setAviso={setAviso} tamanio={'md'} cargando={espera}     
        cerrarBorrar={cerrarBorrar}   btnLeyenda={btnLeyenda}
    >
        
        {DatosGenerales}
    </Modal>             
    )
}

export default ModalAbogado